export interface AppState {
  environment: 'local' | 'preview' | 'staging' | 'live';
  loqateApiKey?: string;
}

export const initialAppState: AppState = {
  environment: 'local',
  // Test Api Key
  loqateApiKey: 'HD43-AZ53-TR11-TE96',
};

export const exampleAppState: AppState = {
  environment: 'local',
  // Test Api Key
  loqateApiKey: 'HD43-AZ53-TR11-TE96',
};

type SET_TEST = 'APP/SET_TEST';

interface SetTestAction {
  type: SET_TEST;
  payload: string;
}

export type AppActionTypes = SetTestAction;

export default function appReducer(state: AppState = initialAppState, action: AppActionTypes): AppState {
  switch (action.type) {
    default: {
      return state;
    }
  }
}
